// ============================================================================
// PLAYER RATINGS — NBA 2K26 Base Ratings
// Source: 2kratings.com/teams (Feb 2026)
// ============================================================================

const PLAYER_RATINGS = {
  // ATL
  'CJ McCollum': 83, 'Jalen Johnson': 88, 'Jonathan Kuminga': 77,
  'Nickeil Alexander-Walker': 83, 'Onyeka Okongwu': 82, 'Corey Kispert': 76,
  'Zaccharie Risacher': 78, 'Gabe Vincent': 73, 'Buddy Hield': 76,
  'Dyson Daniels': 83, 'Asa Newell': 75, 'Jock Landale': 79,
  'Duop Reath': 73, 'Mouhamed Gueye': 74, 'Keaton Wallace': 72,
  'Nikola Djurisic': 70, 'Caleb Houstan': 73, 'Ray J Dennis': 71,
  'Eli Ndiaye': 70, 'Christian Koloko': 73, 'Jacob Toppin': 73,
  'David Roddy': 71, 'Malik Williams': 68,

  // BKN
  'Michael Porter': 86, 'Nicolas Claxton': 82, 'Terance Mann': 74,
  "Day'Ron Sharpe": 78,
  'Egor Demin': 78, 'Ochai Agbaji': 75, 'Ziaire Williams': 76,
  'Cam Thomas': 80, 'H. Highsmith': 73, 'Kobe Bufkin': 71,
  'Nolan Traore': 77, 'Noah Clowney': 77, 'Drake Powell': 73,
  'Dariq Whitehead': 72, 'Ben Saraf': 73, 'Danny Wolf': 77,
  'Josh Minott': 75, 'Hunter Tyson': 71, 'Jalen Wilson': 73,
  'Tyrese Martin': 74, 'E.J. Liddell': 70, 'Tyson Etienne': 70,
  'Chaney Johnson': 69, 'Maxwell Lewis': 70, 'Yuri Collins': 69,
  'David Muoka': 68,

  // BOS
  'Jayson Tatum': 94, 'Jaylen Brown': 95, 'Derrick White': 85,
  'Nikola Vucevic': 83, 'Sam Hauser': 78, 'Payton Pritchard': 83,
  'Hugo Gonzalez': 75, 'Baylor Scheierman': 75, 'Luka Garza': 78,
  'Neemias Queta': 79, 'Jordan Walsh': 77, 'Amari Williams': 69,
  'John Tonje': 69, 'Ron Harper Jr.': 68, 'Max Shulga': 68,
  'RJ Luis Jr.': 69,

  // CHA
  'LaMelo Ball': 86, 'Miles Bridges': 82, 'Josh Green': 74,
  'Grant Williams': 75, 'Coby White': 80, 'Brandon Miller': 86,
  'Mike Conley': 75, 'Pat Connaughton': 73, 'Kon Knueppel': 85,
  'Tre Mann': 74, 'Tidjane Salaun': 76, 'Malaki Branham': 72,
  'Spencer Dinwiddie': 76, 'Liam McNeeley': 72, 'Nick Smith Jr.': 73,
  'Xavier Tillman': 72, 'Moussa Diabate': 80, 'Antonio Reeves': 70,
  'Drew Peterson': 70,

  // CHI
  'Anfernee Simons': 80, 'Josh Giddey': 85, 'Collin Sexton': 80,
  'Zach Collins': 77, 'Patrick Williams': 74, 'Isaac Okoro': 77,
  'Jaden Ivey': 79, 'Jalen Smith': 78, 'Tre Jones': 81,
  'Jevon Carter': 74, 'Rob Dillingham': 72, 'Guerschon Yabusele': 74,
  'Matas Buzelis': 82, 'Noa Essengue': 72, 'Nick Richards': 74,
  'Leonard Miller': 70, 'Mac McClung': 71,

  // CLE
  'Donovan Mitchell': 95, 'Evan Mobley': 87, 'James Harden': 89,
  'Jarrett Allen': 85, 'Max Strus': 77, 'Dennis Schroeder': 79,
  'Sam Merrill': 79, 'Dean Wade': 77, 'Larry Nance Jr.': 73,
  'Jaylon Tyson': 81, 'Thomas Bryant': 74, 'Keon Ellis': 76,
  'Craig Porter': 75, 'Chris Livingston': 72, 'Ricky Rubio': 72,

  // DAL
  'Kyrie Irving': 90, 'Khris Middleton': 77, 'Klay Thompson': 78,
  'Daniel Gafford': 79, 'PJ Washington': 78, 'Cooper Flagg': 87,
  'Caleb Martin': 75, 'Naji Marshall': 79, 'Max Christie': 79,
  'Tyus Jones': 73, 'Dereck Lively': 79, 'Dwight Powell': 73,
  'AJ Johnson': 71, 'Marvin Bagley': 79, 'JaVale McGee': 72,

  // DEN
  'Nikola Jokic': 98, 'Jamal Murray': 90, 'Aaron Gordon': 84,
  'Cameron Johnson': 79, 'Jonas Valanciunas': 79, 'Zeke Nnaji': 74,
  'Christian Braun': 77, 'Peyton Watson': 83, 'Tim Hardaway Jr.': 81,
  'DaRon Holmes': 73, 'Bruce Brown': 75, 'Julian Strawther': 75,
  'Jalen Pickett': 73,

  // DET
  'Cade Cunningham': 94, 'Tobias Harris': 80, 'Kevin Huerter': 77,
  'Duncan Robinson': 78, 'Isaiah Stewart': 80, 'Caris LeVert': 76,
  'Ausar Thompson': 83, 'Ron Holland': 78, 'Jalen Duren': 87,
  'Dario Saric': 74, 'Paul Reed': 75, 'Marcus Sasser': 75,
  'Javonte Green': 77, 'Bobi Klintman': 69, 'Chaz Lanier': 68,

  // GSW
  'Stephen Curry': 95, 'Jimmy Butler': 88, 'Kristaps Porzingis': 84,
  'Draymond Green': 79, 'Moses Moody': 78, 'Al Horford': 79,
  'Brandin Podziemski': 79, 'Gary Payton II': 76, 'De Anthony Melton': 78,
  'Seth Curry': 74, 'Gui Santos': 77, 'Quinten Post': 76,
  'Will Richard': 76, 'Pat Spencer': 77, 'LJ Cryer': 68,
  'Malevy Leons': 68, 'Alex Toohey': 68, 'Jackson Rowe': 68,

  // HOU
  'Kevin Durant': 92, 'Alperen Sengun': 87, 'Fred VanVleet': 80,
  'Steven Adams': 77, 'Dillon Brooks': 85, 'Jabari Smith': 80,
  'Reed Sheppard': 79, 'Amen Thompson': 86, 'Clint Capela': 77,
  'Tari Eason': 81, 'Jeff Green': 73, 'Josh Okogie': 74,
  'Aaron Holiday': 73,

  // IND
  'Pascal Siakam': 87, 'Tyrese Haliburton': 93, 'Ivica Zubac': 85,
  'Andrew Nembhard': 82, 'Obi Toppin': 80, 'Aaron Nesmith': 79,
  'TJ McConnell': 80, 'Jarace Walker': 78, 'Ben Sheppard': 74,
  'Kobe Brown': 72, 'Johnny Furphy': 74, 'Kam Jones': 71,
  'James Wiseman': 72,

  // LAC
  'Kawhi Leonard': 94, 'Darius Garland': 84, 'John Collins': 80,
  'Bojan Bogdanovic': 74, 'Derrick Jones Jr.': 77, 'Bennedict Mathurin': 81,
  'Brook Lopez': 76, 'Isaiah Jackson': 76, 'Nicolas Batum': 74,
  'Kris Dunn': 77, 'Bradley Beal': 77, 'Cam Christie': 70,

  // LAL
  'LeBron James': 92, 'Luka Doncic': 97, 'Rui Hachimura': 79,
  'Austin Reaves': 88, 'Jarred Vanderbilt': 77, 'Luke Kennard': 77,
  'Maxi Kleber': 73, 'Deandre Ayton': 81, 'Jake LaRavia': 77,
  'Marcus Smart': 78, 'Dalton Knecht': 75, 'Jaxson Hayes': 76,
  'Bronny James': 69,

  // MEM
  'Ja Morant': 87, 'Kentavious Caldwell-Pope': 75, 'Santiago Aldama': 81,
  'Brandon Clarke': 78, 'Kyle Anderson': 77, 'Ty Jerome': 81,
  'Georges Niang': 74, 'Taylor Hendricks': 73, 'Zach Edey': 82,
  'Cole Anthony': 76, 'Eric Gordon': 74, 'GG Jackson': 78,
  'Scotty Pippen Jr': 76, 'Jaylen Wells': 77,

  // MIA
  'Bam Adebayo': 88, 'Tyler Herro': 86, 'Andrew Wiggins': 81,
  "Kel'el Ware": 80,
  'Terry Rozier': 74, 'Norman Powell': 86, 'Davion Mitchell': 78,
  'Nikola Jovic': 74, 'Jaime Jaquez': 80, 'Dru Smith': 75,
  'Pelle Larsson': 78, 'Keshad Johnson': 70,

  // MIL
  'Giannis Antetokounmpo': 97, 'Myles Turner': 81, 'Damian Lillard': 88,
  'Kyle Kuzma': 79, 'Bobby Portis': 81, 'Ousmane Dieng': 73,
  'Kevin Porter': 82, 'Ryan Rollins': 81, 'Taurean Prince': 75,
  'Gary Trent Jr.': 76, 'Gary Harris': 74, 'Thanasis Antetokounmpo': 69,
  'AJ Green': 77, 'Andre Jackson Jr.': 71,

  // MIN
  'Anthony Edwards': 96, 'Rudy Gobert': 85, 'Julius Randle': 87,
  'Jaden McDaniels': 83, 'Naz Reid': 83, 'Donte DiVincenzo': 80,
  'Ayo Dosunmu': 80, 'Joan Beringer': 72, 'Joe Ingles': 73,
  'Terrence Shannon': 73, 'Bones Hyland': 77, 'Julian Phillips': 72,
  'Jaylen Clark': 73, 'Johnny Juzang': 72, 'Enrique Freeman': 69,
  'Rocco Zikarsky': 68,

  // NOP
  'Zion Williamson': 87, 'Jordan Poole': 76, 'Dejounte Murray': 81,
  'Trey Murphy': 86, 'Herb Jones': 78, 'Kevon Looney': 74,
  'Jeremiah Fears': 78, 'Saddiq Bey': 82, 'Jordan Hawkins': 71,
  'DeAndre Jordan': 74, 'Yves Missi': 76,

  // NYK
  'Karl-Anthony Towns': 89, 'OG Anunoby': 85, 'Jalen Brunson': 93,
  'Mikal Bridges': 84, 'Josh Hart': 82, 'Mitchell Robinson': 79,
  'Jose Alvarado': 76, 'Miles McBride': 79, 'Jordan Clarkson': 77,
  'Landry Shamet': 77, 'Pacome Dadiet': 69, 'Tyler Kolek': 74,
  'Ariel Hukporti': 72, 'Jeremy Sochan': 75,

  // OKC
  'Shai Gilgeous-Alexander': 98, 'Isaiah Hartenstein': 83, 'Luguentz Dort': 80,
  'Alex Caruso': 79, 'Chet Holmgren': 88, 'Isaiah Joe': 80,
  'Aaron Wiggins': 78, 'Jaylin Williams': 78, 'Jalen Williams': 87,
  'Cason Wallace': 80, 'Nikola Topic': 72, 'Jared McCain': 76,
  'Mason Plumlee': 76, 'Ajay Mitchell': 82,

  // ORL
  'Franz Wagner': 87, 'Desmond Bane': 84, 'Jalen Suggs': 83,
  'Paolo Banchero': 87, 'Jonathan Isaac': 73, 'Wendell Carter': 80,
  'Goga Bitadze': 76, 'Anthony Black': 83, 'Jett Howard': 73,
  'Moritz Wagner': 77, 'Tristan da Silva': 75,

  // PHI
  'Joel Embiid': 92, 'Paul George': 82, 'Tyrese Maxey': 93,
  'VJ Edgecombe': 81, 'Quentin Grimes': 77, 'Kelly Oubre Jr.': 78,
  'Andre Drummond': 78, 'Dominick Barlow': 78, 'Kyle Lowry': 74,
  'Adem Bona': 75, 'Johni Broome': 70,

  // PHX
  'Devin Booker': 93, 'Jalen Green': 81, 'Bradley Beal': 77,
  "Royce O'Neale": 77,
  'Grayson Allen': 83, 'Neale': 77, 'Mark Williams': 82,
  'Khaman Maluach': 73, 'Nassir Little': 74, 'Ryan Dunn': 74,
  'Collin Gillespie': 81, 'Oso Ighodaro': 75, 'Rasheer Fleming': 71,

  // POR
  'Jrue Holiday': 83, 'Jerami Grant': 82, 'Deandre Ayton': 81,
  'Deni Avdija': 88, 'Damian Lillard': 88, 'Robert Williams': 78,
  'Matisse Thybulle': 75, 'Scoot Henderson': 78, 'Shaedon Sharpe': 85,
  'Donovan Clingan': 84, 'Kris Murray': 74, 'Toumani Camara': 82,

  // SAC
  'Zach LaVine': 83, 'Domantas Sabonis': 86, 'DeMar DeRozan': 84,
  "De'Andre Hunter": 79,
  'Malik Monk': 79, 'Keegan Murray': 79, 'Devin Carter': 75,
  'Russell Westbrook': 80, 'Nique Clifford': 77, 'Maxime Raynaud': 79,

  // SAS
  'Devin Vassell': 82, 'Harrison Barnes': 77, 'Keldon Johnson': 80,
  "De'Aaron Fox": 86,
  'Kelly Olynyk': 76, 'Victor Wembanyama': 96, 'Dylan Harper': 80,
  'Luke Kornet': 78, 'Stephon Castle': 85, 'Carter Bryant': 73,
  'Bismack Biyombo': 70, 'Julian Champagnie': 78,

  // TOR
  'Scottie Barnes': 87, 'Brandon Ingram': 86, 'Immanuel Quickley': 84,
  'RJ Barrett': 82, 'Jakob Poeltl': 80, 'Chris Murray-Boyles': 80,
  'Gradey Dick': 76, 'Ja Kobe Walter': 76, 'Chris Paul': 74,
  'Garrett Temple': 70,

  // UTA
  'Lauri Markkanen': 87, 'Jaren Jackson Jr.': 86, 'Jusuf Nurkic': 82,
  'Lonzo Ball': 74, 'Ace Bailey': 79, 'John Konchar': 75,
  'Cody Williams': 76, 'Walker Kessler': 83, 'Keyonte George': 87,
  'Kevin Love': 76, 'Svi Mykhailiuk': 76, 'Kyle Filipowski': 79,
  'Brice Sensabaugh': 79, 'Isaiah Collier': 82,

  // WAS
  'Anthony Davis': 92, 'Trae Young': 88, 'Alex Sarr': 84,
  "D'Angelo Russell": 76,
  'Tre Johnson': 79, 'Bilal Coulibaly': 78, 'Jaden Hardy': 73,
  'Carlton Carrington': 77, 'Cameron Whitmore': 75, 'Will Riley': 78,
  'Blake Wesley': 73, 'Dante Exum': 75, 'Kyshawn George': 82,
  'Anthony Gill': 72, 'Sharife Cooper': 72, 'Tristan Vukcevic': 74,
  'Jamir Watkins': 70, 'Richaun Holmes': 73, 'Skal Labissiere': 69,

  // 2026
  'Darryn Peterson': 84, 'Cameron Boozer': 82, 'AJ Dybantsa': 82,
  'Caleb Wilson': 80, 'Kingston Flemings': 78, 'Darius Acuff Jr.': 78,
  'Mikel Brown Jr.': 75, 'Keaton Wagler': 75, 'Hannes Steinbach': 75,
  'Nate Ament': 74, 'Braylon Mullins': 74, 'Labaron Philon': 74,
  'Yaxel Lendeborg': 73, 'Brayden Burries': 73, 'Tounde Yessoufou': 73,
  'Koa Peat': 72, 'Thomas Haugh': 72, 'Bennett Stirtz': 72,
  'Jayden Quaintance': 71, 'Patrick Ngongba II': 71, 'Cameron Carr': 71,
  'Chris Cenac Jr.': 70, 'Karim López': 70, 'Christian Anderson': 70,
  'Joshua Jefferson': 70, 'Tyler Tanner': 69, 'Malachi Moreno': 69,
  'Flory Bidunga': 69, 'Morez Johnson Jr.': 69, 'Aday Mara': 68,
  'Dailyn Swain': 68, 'Sergio de Larrea': 68, 'Ebuka Okorie': 67,
  'Amari Allen': 67, 'Zuby Ejiofor': 67, 'Braden Smith': 67,
  'Henri Veesaar': 66, 'Isaiah Evans': 66, 'Meleek Thomas': 66,
  'JT Toppin': 66, 'Richie Saunders': 66, 'Juke Harris': 65,
  'Paul McNeil Jr.': 65, 'Alex Karaban': 65, 'JoJo Tugler': 65,
  'Dash Daniels': 64, 'Ryan Conwell': 64, 'Tarris Reed Jr.': 64,
  'Alex Condon': 64, 'Motiejus Krivas': 63, 'Milan Momcilovic': 63,
  'Bruce Thornton': 63, 'Jaden Bradley': 63, 'Tamin Lipsey': 62,
  'Miles Byrd': 62, 'Nate Bittle': 62, 'Darrion Williams': 62,
  'Zvonimir Ivisic': 61, 'Tomislav Ivisic': 61, 'Milos Uzan': 61,

  // Free Agent Ratings (2K26)
  'Malik Beasley': 78,   'Ben Simmons': 77,   'Malcolm Brogdon': 77,
  'Jeremiah Robinson-Earl': 75,   'Torrey Craig': 74,   'DaQuan Jeffries': 74,
  'Brandon Boston Jr.': 74,   'Trey Lyles': 74,   'Cody Martin': 74,
  'Shake Milton': 74,   'Keon Johnson': 74,   'Alec Burks': 74,
  'Garrison Mathews': 73,   'Kenyon Martin Jr.': 73,   'Tony Bradley': 73,
  'Reggie Jackson': 73,   'Damion Lee': 73,   'Delon Wright': 73,
  'Bol Bol': 73,   'Chris Boucher': 73,   'Jae Crowder': 73,
  'Cory Joseph': 72,   'Jalen McDaniels': 72,   'Orlando Robinson': 72,
  'Ricky Council IV': 72,   'Monte Morris': 72,   'Daniel Theis': 72,
  'Jared Butler': 72,   'Lonnie Walker IV': 72,   'Elfrid Payton': 72,
  'Christian Wood': 72,   'Cam Reddish': 72,   'Kessler Edwards': 72,
  'Chris Duarte': 71,   'Jaden Springer': 71,   'Jared Rhoden': 71,
  'Vlatko Cancar': 71,   'Trevelin Queen': 71,   'Colby Jones': 71,
  'Patty Mills': 71,   'Josh Richardson': 71,   'Jeff Dowtin': 71,
  'Mo Bamba': 71,   'Terence Davis': 71,   'Talen Horton-Tucker': 71,
  'P.J. Tucker': 71,   'Terry Taylor': 71,   'Markelle Fultz': 71,
  'Lamar Stevens': 71,   'Chuma Okeke': 70,   'Alex Reese': 70,
  'Cole Swider': 70,   'Lester Quinones': 70,   'P.J. Dozier': 70,
  'Kevin Knox II': 70,   'Kylor Kelley': 70,   'Johnny Davis': 70,
  'Jalen Hood-Schifino': 70,   'Oshae Brissett': 70,   'Alex Len': 70,
  'Jaylen Nowell': 70,   'JT Thor': 70,   'Stanley Umude': 70,
  'Malachi Flynn': 70,   'Kai Jones': 70,   'Bruno Fernando': 70,
  'Taj Gibson': 70,   'Markieff Morris': 70,   'Jahlil Okafor': 70,
  'Cody Zeller': 70,   'Matt Ryan': 70,   'Moses Brown': 70,
  'James Johnson': 70,   'Tristan Thompson': 70,   'Josh Christopher': 70,
  'Justin Minaya': 69,   'Luke Travers': 69,   'Reece Beekman': 69,
  'David Duke Jr.': 69,   'Tyler Smith': 69,   'Trentyn Flowers': 69,
  'Daishen Nix': 69,   'Mason Jones': 69,   "N'Faly Dante": 68,

};


// Some players appear on multiple teams in trade scenarios — rating follows the player

// Color tier helper
export const getRatingColor = (ovr) => {
  if (ovr >= 95) return '#6b5b95'; // Muted purple — elite
  if (ovr >= 90) return '#9b4d56'; // Muted rose — superstar
  if (ovr >= 85) return '#b07d3a'; // Muted amber — all-star
  if (ovr >= 80) return '#4a7c6f'; // Muted teal — starter
  if (ovr >= 75) return '#6b7f99'; // Muted slate — role player
  return '#9a9083';                 // Warm gray — bench
};

// Tier label helper
export const getRatingTier = (ovr) => {
  if (ovr >= 95) return 'ELITE';
  if (ovr >= 90) return 'SUPERSTAR';
  if (ovr >= 85) return 'ALL-STAR';
  if (ovr >= 80) return 'STARTER';
  if (ovr >= 75) return 'ROLE';
  return 'BENCH';
};

// Returns the ORIGINAL static rating, ignoring any progression overrides.
// Used for progression floor checks to prevent compounding drift.
export const getBasePlayerRating = (name) => {
  if (PLAYER_RATINGS[name] !== undefined) return PLAYER_RATINGS[name];
  const lower = name.toLowerCase();
  for (const [k, v] of Object.entries(PLAYER_RATINGS)) {
    if (k.toLowerCase() === lower) return v;
    const lastName = k.split(' ').pop().toLowerCase();
    const searchLast = name.split(' ').pop().toLowerCase();
    if (lastName === searchLast && lastName.length > 3) {
      if (k[0].toLowerCase() === name[0].toLowerCase()) return v;
    }
  }
  return null; // null = unknown player (no static rating)
};

export const getPlayerRating = (name) => {
  // Check runtime overrides (from player progression between seasons)
  if (typeof window !== 'undefined' && window.__ratingOverrides && window.__ratingOverrides[name] !== undefined) {
    return window.__ratingOverrides[name];
  }
  // Direct match
  if (PLAYER_RATINGS[name] !== undefined) return PLAYER_RATINGS[name];
  // Try partial match (handles Jr. / III / etc variations)
  const lower = name.toLowerCase();
  for (const [k, v] of Object.entries(PLAYER_RATINGS)) {
    if (k.toLowerCase() === lower) return v;
    // Last name match as fallback
    const lastName = k.split(' ').pop().toLowerCase();
    const searchLast = name.split(' ').pop().toLowerCase();
    if (lastName === searchLast && lastName.length > 3) {
      // Check first initial too
      if (k[0].toLowerCase() === name[0].toLowerCase()) return v;
    }
  }
  return 72; // Default for unknown players
};

export default PLAYER_RATINGS;